<template lang="pug">
.receipt-container.p-4.border.border-gray-300.rounded-lg.max-w-md.mx-auto
  h1.text-2xl.font-bold.text-center.mb-4 Payment Receipt
  .company-info.mb-4
    h2.text-xl.font-semibold ARBA Travel & Tours Sdn Bhd
    p K-3-01, Conezion, City, 
    p Persiaran IRC 3, Ioi Resort, 
    p 62502 Putrajaya, Selangor

    p This is to confirm that a payment of {{data.paymentAmount}} has been made for the INVOICE  {{ data.invoiceNumber }}
  .receipt-details.space-y-2
    .flex.justify-between
      span.font-medium Invoice Number:
      span {{ data.invoiceNumber }}
    .flex.justify-between
      span.font-medium Payment Date:
      span {{ data.paymentDate }}
    .flex.justify-between
      span.font-medium Payment Amount:
      span {{ data.paymentAmount }}
    .flex.justify-between
      span.font-medium Payment Method:
      span {{ data.paymentMethod }}
    .flex.justify-between
      span.font-medium Customer Name:
      span {{ data.customerName }}
  .mt-8.text-center.text-sm.text-gray-600 This Receipt is digitally generated. No signature is needed.
</template>

<script>
export default {
  name: 'ReceiptTemplate',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* You can add any component-specific styles here */
</style>